module.exports = __webpack_public_path__ + "img/icons BFr_11.90d7e522.png";